// extracted by mini-css-extract-plugin
var _1 = "MobileElement_answers__5f925";
var _2 = "MobileElement_emptyAnswer__fc37e";
var _3 = "MobileElement_groups__61cd9";
var _4 = "MobileElement_root__7d998";
export { _1 as "answers", _2 as "emptyAnswer", _3 as "groups", _4 as "root" }
